import SearchSelectElement from "../../../../shared/form/SearchSelectElement";
import InputElement from "../../../../shared/form/InputElement";
import infoIconSvg from "../../../../assets/img/Icon-metro-info.svg";
import InfoPopover from "../../../../shared/form/InfoPopover";

const FieldRenderer = ({ field }) => {
  const {
    type,
    colClass = "col-md-4",
    stylesRequestData,
    required,
    errorText,
  } = field;

  // shared label class used by both
  const labelClassName = `${
    required ? "required " : ""
  } ${stylesRequestData?.["form-label"] ?? ""} form-label`;

  const errorProps = {
    pClassName: "text-danger mb-0 mt-2 me-2 fw-bolder",
    pText: errorText,
  };

  if (type === "input") {
    return (
      <div className={colClass}>
        <InputElement
          value={field.value}
          disabled={field.disabled}
          name={field.name}
          onChange={field.onChange}
          mb4="mb-4"
          labelHtmlFor={field.labelHtmlFor}
          labelClassName={labelClassName}
          labelText={field.labelText}
          inputType={field.inputType}
          inputClassName={`${stylesRequestData["form-control"]} form-control`}
          inputID={`${field.name}_input`}
          allowedPattern={field.allowedPattern}
          maxLength={field.maxLength}
          placeholder={field.placeholder}
          popover={field?.popover}
          {...errorProps}
        />
      </div>
    );
  }

  if (type === "select") {
    return (
      <div className={colClass}>
        <SearchSelectElement
          mb4="mb-4"
          labelHtmlFor={field.labelHtmlFor}
          labelClassName={labelClassName}
          labelText={field.labelText}
          selectClassName={`${stylesRequestData["form-select"]} form-select`}
          selectID={`${field.name}_select_id`}
          inputId={`${field.name}_input`}
          name={field.name}
          options={field.options}
          default={field.defaultText}
          value={field.value}
          onChange={field.onChange}
          type={field.valueType} // your existing `type="string"`
          disabled={field.disabled}
          isMulti={field.isMulti}
          isClearable={field?.isClearable}
          cursorIfEmpty={field?.cursorIfEmpty}
          components={field?.components}
          isOptionDisabled={field?.isOptionDisabled}
          {...errorProps}
        />
      </div>
    );
  }

  if (type === "checkbox") {
    const wrapperClassName = field.wrapperClassName ?? "list-group border-0";
    const disabledCheckboxStyle = field.disabled
      ? {
          accentColor: "#a6a6a6",
          backgroundColor: "#d9d9d9",
          borderColor: "#a6a6a6",
        }
      : {};

    const finalLabelClassName = `${
      field.required ? "required " : ""
    }${field.labelClassName ?? ""}`;

    return (
      <div className={field.colClass ?? "col-12"}>
        <div className={wrapperClassName}>
          <div
            className="d-flex align-items-center"
            style={{ gap: "10px", marginTop: "10px" }}
          >
            {/* Checkbox */}
            <input
              type="checkbox"
              className={field.inputClassName}
              style={{ ...disabledCheckboxStyle, ...(field.inputStyle ?? {}) }}
              name={field.name}
              id={field.id}
              checked={!!field.checked}
              disabled={field.disabled}
              onChange={field.onChange}
            />

            {/* First text */}
            <span style={field.textStyle ?? { fontSize: "15px" }}>
              {field.text}
            </span>

            {/* Popover OR Tooltip */}
            {field?.popover ? (
              <InfoPopover
                content={field.popover.content}
                allowHtml={field.popover.allowHtml}
              >
                <img
                  src={infoIconSvg}
                  alt="info"
                  width="18"
                  height="18"
                  style={{ display: "block", cursor: "pointer" }}
                />
              </InfoPopover>
            ) : (
              field?.tooltip && (
                <button
                  type="button"
                  className="btn btn-link p-0 ms-2"
                  style={{ textDecoration: "none" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement={field.tooltip.placement ?? "top"}
                  title={field.tooltip.text}
                  aria-label="مساعدة"
                >
                  <span
                    className="d-inline-flex align-items-center justify-content-center"
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      border: "1px solid #0d6efd",
                      color: "#0d6efd",
                      fontSize: 12,
                      lineHeight: 1,
                    }}
                  >
                    i
                  </span>
                </button>
              )
            )}

            {/* Second text */}
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
              }}
            >
              {field.secondText}
            </span>
          </div>

          {field.errorText && (
            <p
              className={
                field.errorClassName ?? "text-danger mb-0 mt-1 me-4 fw-bolder"
              }
              id={field.errorId}
            >
              {field.errorText}
            </p>
          )}
        </div>
      </div>
    );
  }

  // fallback for unknown type
  return null;
};
export default FieldRenderer;
